import { useEffect, useState } from "react";
import PageHeader from "../../Layout/PageHeader";
import Table, { Column } from "../../Components/Tables/Table";
import { ThreeDotsVertical } from "react-bootstrap-icons"
import CommonConfirmationModal from "../../Components/Modals/CommonConfirmationModal";
import CommonModal from "../../Components/Modals/CommonModal";
import { InventoryStatusEditLayout } from "../../Layout/InventoryStatusEditLayout";
import { getInventoryStatus, submitInventoryStatus } from "./service/inventorystatus.service";
import { InventoryStatusData } from "./model/inventorystatus.type";
import Loader from "../../Components/GlobalLoader/Loader";
import { useSearchStore } from "../../store/search/searchStore";
import { Toaster, toast } from "react-hot-toast";
import { ApiResponse } from "../../model/common/apiResponse";

export default function InventoryStatusOverview() {
  const pageName = "Inventory Status";
  const [isShowCanvas, setShowCanvas] = useState(false);
  const [showconfModal, setShowconfModal] = useState(false);
  const handleconfClose = () => setShowconfModal(false);
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(!show);
  const [inputValue, setInputValue] = useState("");
  const [selectedRow, setSelectedRow] = useState("");
  const [inventoryStatusData, setInventoryStatusData] = useState<InventoryStatusData[]>([]);
  const [loading, setLoading] = useState(true);
  const { searchTerm, resetSearch, previousSearchTerm, setPreviousTerm } =
    useSearchStore();
    const isAddButtonEnabled = inputValue.trim() !== "";

  const handleGlobalFilter = () => {
    setShowCanvas(!isShowCanvas);
  };
  const handleGlobalSearch = () => { };
  const onCurrentPageChange = (page: number) => {
    // Handle page change here if needed
    console.log("Page changed to:", page);
  };
  useEffect(() => {
    resetSearch();
  }, [resetSearch]);
  useEffect(() => {
    setLoading(true);
    getInventoryStatus().then((response) => {
      if (response.status == 200) {
        if (searchTerm) {
          const filteredData = response.data.filter((invstatus: any) => {
            return invstatus.description.toLowerCase().includes(searchTerm.toLowerCase());
          })
          setInventoryStatusData(filteredData);
        } else {
          setInventoryStatusData(response.data);
        }
      }
    }).finally(() => {
      setLoading(false);
    });
  }, [searchTerm, resetSearch]);

  const columns: Column[] = [
    {
      name: "Inventory Status",
      selector: (row: InventoryStatusData) => <span>{row.description ? row.description : null}</span>,
    },
    // {
    //   name: <></>,
    //   selector: (row: any) => (
    //     <>
    //       <span
    //         className="cursor-pointer dropdown-toggle action-menu border-none list-ellipse-ms"
    //         data-bs-toggle="dropdown"
    //         aria-expanded="false"
    //       >
    //         <ThreeDotsVertical />
    //       </span>
    //       <ul className="dropdown-menu action-items px-0 py-1">
    //         <li
    //           className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
    //           onClick={() => handelEditAction(row)}
    //         >
    //           Edit
    //         </li>
    //         <li
    //           className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
    //           onClick={() => handelDeleteAction(row)}
    //         >
    //           Delete
    //         </li>
    //       </ul>
    //     </>
    //   ),
    // },
  ];
  const handelDeleteAction = (data: InventoryStatusData) => {
    console.log('data for delete:', data);
    setShowconfModal(true);
  };
  const handelEditAction = (data: any) => {
    setSelectedRow(data);
    setShow(true);
    console.log("handelEdit", data.status);
  };
  const onModalSubmit = (response: boolean) => {
    console.log(response);
    handleconfClose();
  };
  const handleAddClick = async () => {
    if (inputValue.trim()) {
      const payload = {
        "type": "inventories.status",
        "code": inputValue,
        "description": inputValue
      }
      const response = await submitInventoryStatus(payload);
      if (response?.status === 201) {
        setInventoryStatusData([...inventoryStatusData, payload]);
        resetSearch();
        toast.success("Inventory Status added successfully!", { duration: 2000 });
      } else {
        toast.error(response?.error?.detail, { duration: 2000 });
      }
      setInputValue("");
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  return !loading ? (
    <>
      <Toaster />
      <PageHeader
        listUrl="/account/client/inventory-status"
        hideAddButton={true}
        handleGlobalFilter={handleGlobalFilter}
        handleGlobalSearch={handleGlobalSearch}
      />
      <div className="clearfix"></div>

      <h5 className="text-start mt-1 mb-3">{pageName}</h5>

      <div className="my-2 bg-white rounded  p-4 d-flex flex-column">
        <div className="row">
          <div className=" d-flex justify-content-between">
            <div className="col-5">
              <label className="fw-medium">Inventory Status</label>
              <div className="mt-2">
                <input
                  tabIndex={2}
                  maxLength={50}
                  type="text"
                  name="InventoryStatus"
                  className="form-control"
                  placeholder="Enter Inventory Status"
                  value={inputValue}
                  // onChange={(e) => setInputValue(e.target.value)}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="my-auto d-flex justify-content-end col-7">
              <button
                className={`ms-3 fs-14 ${
                  isAddButtonEnabled ? "sph-btn" : "sph-btn-disabled"
                }`}
                disabled={!isAddButtonEnabled}
                onClick={handleAddClick}
              >
                + Add
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="inventory-status-table mt-4">
        <Table
          columns={columns}
          data={inventoryStatusData}
          pagination={{
            paginationType: "client",
            recordsPerPage: 10,
            totalRecords: inventoryStatusData.length,
            onCurrentPageChange: onCurrentPageChange,
          }}
          CheckboxStatus={false}
          customClassName="p-4"
        />
      </div>
      <CommonModal
        handleClose={handleShow}
        show={show}
        heading="Inventory Status"
        content={<InventoryStatusEditLayout selectedRow={selectedRow} />}
        modalSize="modal-md"
        footerButtonsActive={true}
        customClassNameForFooter="inventory-status-modal-footer"
      />
      <CommonConfirmationModal
        customClassName="header-border"
        show={showconfModal}
        content={
          <>
            {" "}
            You are about to delete this Inventory Status <br />
            Are you Sure?{" "}
          </>
        }
        onModalSubmit={onModalSubmit}
        confirmBtnText={"Yes"}
        cancelBtnText={"No"}
      />
    </>
  ) : <Loader />;
}
